export default __webpack_public_path__ + "static/media/note-taker.271bfa19.png";